module.exports = __webpack_public_path__ + "static/media/EMC-agenda.7370db8b.jpg";